import React from 'react';
import styled from 'styled-components';

import Checkbox from '../Checkbox';

const Container = styled.div``;

const CheckboxGroup = ({ label, value = [], options, onChange }) => {
  const handleChange = (key) => () => {
    if (value.includes(key)) {
      onChange(value.filter((v) => v !== key));
    } else {
      onChange([...value, key]);
    }
  };

  return (
    <Container>
      {label && (
        <span className="text-md leading-23 text-black mb-2">{label}</span>
      )}
      {options.map(({ key, label: lb }) => (
        <Checkbox
          key={key}
          checked={value.includes(key)}
          label={lb}
          onClick={handleChange(key)}
        />
      ))}
    </Container>
  );
};

export default CheckboxGroup;
